<template>
  <v-container class="grey-lighten-3 full-height">
    <!-- Printable Bonus Area -->
    <v-row justify="center">
      <v-col cols="12" xl="10" lg="11" md="12">
        <v-sheet
          class="invoice-paper pa-8 mx-auto"
          elevation="3"
          id="printable-area"
        >

            <div class="header-section d-flex justify-space-between align-start lines">
                <div class="company-info">
                    <h4 class="company-name text-uppercase font-weight-bold mb-1">
                        {{ getEmployeeBonusDetails?.branch?.company?.name }}
                    </h4>
                    <p class="company-text mb-1" style="width:65%">{{ getEmployeeBonusDetails?.branch?.company?.address }}</p>
                    <p class="company-text mb-1">
                        <v-icon size="small" class="mr-1">mdi-phone-outline</v-icon>
                        {{ getEmployeeBonusDetails?.branch?.company?.mobile }}
                    </p>
                    <p class="company-text mb-1">
                        <v-icon size="small" class="mr-1">mdi-email-outline</v-icon>
                        {{ getEmployeeBonusDetails?.branch?.company?.email }}
                    </p>
                    <p class="company-text" v-if="getEmployeeBonusDetails?.branch?.company?.website">
                        <v-icon size="small" class="mr-1">mdi-web</v-icon>
                        {{ getEmployeeBonusDetails?.branch?.company?.website }}
                    </p>
                </div>

                <div class="logo-container">
                    <v-img
                        :src="`${getFileServerUrl.replace(/\/$/, '')}/${getEmployeeBonusDetails?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                        max-width="150" 
                        max-height="70" 
                        class="logo-img" 
                        contain
                    />
                </div>
            </div>

          <!-- Title -->
          <div class="text-center mb-6">
            <h1 class="report-title text-h6 font-weight-bold text-decoration-underline">
              Employee Bonus Details
            </h1>
            <h2 class="text-h6 font-weight-bold">
              FY - {{ getEmployeeBonusDetails?.bonus_process_master?.year || "2025" }}
            </h2>
          </div>

          <!-- Employee Info -->
          <div class="meta-info-box mb-4">
            <div class="d-flex">
              <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000">
                <span class="meta-label pl-2">Employee:</span>
                <span class="meta-value pl-2 font-weight-bold">
                  {{ getEmployeeBonusDetails?.employee?.name || "__________" }}
                </span>
              </div>
              <div class="meta-item d-flex align-center" style="width: 50%;">
                <span class="meta-label pl-2">Employee Code:</span>
                <span class="meta-value pl-2 font-weight-bold">
                  {{ getEmployeeBonusDetails?.employee?.code || "__________" }}
                </span>
              </div>
            </div>
            <div class="d-flex">
              <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                <span class="meta-label pl-2">Department:</span>
                <span class="meta-value pl-2 font-weight-bold">
                  {{ getEmployeeBonusDetails?.department?.name || "__________" }}
                </span>
              </div>
              <div class="meta-item d-flex align-center" style="width: 50%">
                <span class="meta-label pl-2">Designation:</span>
                <span class="meta-value pl-2 font-weight-bold">
                  {{ getEmployeeBonusDetails?.designation?.name || "__________" }}
                </span>
              </div>
            </div>
          </div>

          <!-- Bonus Details Table -->
          <div class="table-container mb-6">
            <table class="jv-table">
              <thead>
                <tr>
                  <th>SL</th>
                  <th>Detail</th>
                  <th class="text-right">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Gross Salary</td>
                  <td class="text-right">{{ formatNumber(getEmployeeBonusDetails.gross_salary) }}</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Basic Salary</td>
                  <td class="text-right">{{ formatNumber(getEmployeeBonusDetails.basic_salary) }}</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Bonus Percent</td>
                  <td class="text-right">{{ formatNumber(getEmployeeBonusDetails.bonus_percent) }}%</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Bonus Amount</td>
                  <td class="text-right">{{ formatNumber(getEmployeeBonusDetails.bonus_amount) }}</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Revenue Stamp</td>
                  <td class="text-right">{{ formatNumber(getEmployeeBonusDetails.revenue_stamp) }}</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Payable Amount</td>
                  <td class="text-right">{{ formatNumber(getEmployeeBonusDetails.payable_amount) }}</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Paid Amount</td>
                  <td class="text-right">{{ formatNumber(getEmployeeBonusDetails.paid_amount) }}</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Remaining Amount</td>
                  <td class="text-right">{{ formatNumber(getEmployeeBonusDetails.remaining_amount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Remarks -->
          <div class="narration-section mb-8">
            <div class="font-weight-bold mb-1">Remarks:</div>
            <div class="narration-content lines">
              {{ getEmployeeBonusDetails.remarks || "__________________________________________________________________________________" }}
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Action Toolbar -->
    <v-row class="d-print-none mb-4" justify="center">
      <v-col cols="12" md="8" lg="9" class="d-flex justify-center gap-2">
        <v-btn color="success" prepend-icon="mdi-download" @click="downloadPDF">
          Download PDF
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "EmployeeBonusPDF",
  data() {
    return {
      bonusData: {},
    };
  },
  computed: {
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
    getEmployeeBonusDetails(){
        return this.$store.getters.getEmployeeBonusDetails;
    }
  },
  methods: {
    formatNumber(num) {
      if (!num) return "0.00";
      return parseFloat(num).toFixed(2);
    },
    async downloadPDF() {
      const element = document.getElementById('printable-area');
      const opt = {
        margin: [0.5, 0.5],
        filename: `employee-bonus.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, logging: false },
        jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' },
      };
      try {
        await html2pdf().set(opt).from(element).save();
      } catch (error) {
        console.error('PDF generation failed:', error);
      }
    },
  },
  mounted() {
    const id = this.$route.params.id;
    this.$store.dispatch("getEmployeeBonusDetails", id);
  },
};
</script>

<style scoped>
.invoice-paper {
  background-color: white;
  color: black;
  font-family: "Times New Roman", serif;
  width: 100%;
  padding: 20px;
  min-height: 297mm;
}

.meta-info-box {
  border: 1px solid #000;
  margin-bottom: 15px;
}

.meta-item {
  padding: 5px 10px;
  height: 35px;
}

.jv-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.jv-table th,
.jv-table td {
  border: 1px solid #000;
  padding: 8px 5px;
  text-align: left;
}

.jv-table td.text-right {
  text-align: right;
}

.narration-content {
  border-bottom: 1px solid #ccc;
  min-height: 60px;
  padding: 5px 0;
  white-space: pre-wrap;
}
</style>
